<template>
  <div class="content-message">
    <div class="top">
      <div class="back" @click="back">
        <img src="@/assets/img/icon_return.png" alt="">
        <div class="back-text">返回</div>
      </div>
      <div class="title"> {{success?'支付成功':'支付失败'}}</div>
    </div>
    <div class="center">
      <div class="top">
        <img
          :src="success?require('@/assets/img/pay_icon_pay_succeed.png'):require('@/assets/img/pay_icon_pay_failure.png')"
          alt="">
        <div class="top-message">
          <div class="top-message-title" :style="success?'':'color: #FF4F76'">
            {{ success ? '支付成功!' : '支付失败' }} <span v-if="success && typeStatus ==1" style="color: #000000">你可以点击下方按钮授权公众号</span>
          </div>
          <div class="top-message-text">支付单号：{{ orderUuid }}</div>
        </div>
      </div>
      <div class="center-hint" v-if="success && buyType ==1">由于您是首次购买，赠送您一个票务号席位（一年）</div>
      <div class="center-text" v-if="success && buyType ==1" >公众号授权成功后，请前往 <span @click="goTicket()">添加票务号<img src="@/assets/img/icon_arrow_2.png" alt=""></span></div>
      <div class="center-text" v-if="success && buyType !=1 && payStatus == 1" >恭喜您购买成功！<span @click="goTicket()">添加票务号<img src="@/assets/img/icon_arrow_2.png" alt=""></span></div>
      <div class="center-text" v-if="success && payStatus == 2 &&  buyType !=1" >恭喜您续费成功！</div>
<!--      <div class="center-qrcode" v-if="success">-->
<!--        <div class="qrcode-div">-->
<!--          <div class="qrcode-div-title">绑定公众号</div>-->
<!--          <img src="" alt="">-->
<!--          <div class="qrcode-div-text">请使用公众号管理员账号，扫码二维码</div>-->
<!--          <div class="qrcode-div-button">刷新</div>-->
<!--        </div>-->
<!--        <div class="qrcode-div">-->
<!--          <div class="qrcode-div-title">绑定票务号</div>-->
<!--          <img src="" alt="">-->
<!--          <div class="qrcode-div-text">请使用公众号管理员账号，扫码二维码</div>-->
<!--          <div class="qrcode-div-button">刷新</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="bottom" v-if="typeStatus == 1">
      <div><img class="img" src="../../../../assets/img/kfc/wechat_shouquanshuoming.png" alt=""></div>
      <div>
        <div class="bottom-title">授权说明</div>
        <div class="bottom-item">
          <div class="bor"></div>
          <div class="item-text">授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</div>
        </div>
        <div class="bottom-item">
          <div class="bor"></div>
          <div class="item-text">如果你是公众号的管理员，点击下方按钮，扫码授权即可。</div>
        </div>
        <div class="bottom-item">
          <div class="bor"></div>
          <div class="item-text">如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</div>
        </div>
        <div class="bottom-button">
          <iframe  frameborder="0" :src="authLink" style="width: 200px;height: 36px;"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserUUID} from '@/utils/auth'
export default {
  name: "paymentStatus",
  data() {
    return {
      success: true,
      orderUuid:'',
      buyType:'',
      typeStatus:'',
      payStatus:'',
      authLink:process.env.VUE_APP_NEW_OPEN_URL + '/third/go/auth-pub?source=SAASMOVIE&goUrl=' + encodeURIComponent(encodeURIComponent(window.location.href)) + '&userUUID='+ getUserUUID() + '&buttonText=点击开始授权公众号',
    }
  },
  mounted() {
    // this.doSend()
    this.orderUuid = localStorage.getItem('orderUuid')
    this.success = localStorage.getItem('paySuccess')
    this.buyType = localStorage.getItem('buyType')
    this.typeStatus = localStorage.getItem('typeStatus')
    this.payStatus = localStorage.getItem('payStatus')
    console.log('typeStatus',this.typeStatus)
  },
  methods: {
    // 返回
    back() {
      this.$router.back()
    },
    goOfficial(){
      this.$router.push('/pc/SaasJoin/official/index')
    },
    goTicket(){
      this.$router.push('/pc/SaasJoin/ticketIn/index')
    }
  }
}
</script>

<style scoped lang="less">
.content-message {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  position: relative;

  .top {
    display: flex;
    align-items: center;

    .back {
      width: 88px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img {
        width: 24px;
        height: 24px;
      }

      .back-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
      }
    }

    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
      margin-left: 20px;
    }
  }

  .center {
    width: 64%;
    margin: auto;
    margin-top: 60px;

    .top {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 60px;
        height: 60px;
      }

      .top-message {
        margin-left: 20px;

        .top-message-title {
          font-size: 24px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #51C456;
          line-height: 33px;
        }

        .top-message-text {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #999999;
          line-height: 20px;
          margin-top: 8px;
        }
      }
    }

    .center-hint {
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 22px;
      margin-top: 50px;
      text-align: center;
    }

    .center-qrcode {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 30px;

      .qrcode-div {
        width: 320px;
        height: 302px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        text-align: center;

        .qrcode-div-title {
          font-size: 16px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          line-height: 22px;
          margin-top: 20px;
        }

        img {
          width: 140px;
          height: 140px;
          margin-top: 16px;
        }

        .qrcode-div-text {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          line-height: 20px;
          margin-top: 10px;
        }

        .qrcode-div-button {
          width: 61px;
          height: 28px;
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #EEEEEE;
          text-align: center;
          font-size: 12px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #3D9EFC;
          line-height: 28px;
          margin: auto;
          margin-top: 16px;
        }
      }
    }
  }

  .bottom {
    width: 64%;
    margin: auto;
    margin-top: 100px;
    display: flex;
    .img{
      width: 218px;
      height: 138px;
      margin-right: 70px;
    }

    .bottom-title {
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 27px;
    }

    .bottom-item {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .bor {
        width: 6px;
        height: 6px;
        background: #FF8622;
        border-radius: 100%;
      }

      .item-text {
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 22px;
        margin-left: 5px;
        width: 99%;
      }
    }
    .bottom-button{
      width: 200px;
      height: 36px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
      margin-top: 30px;
      cursor: pointer;
    }
  }
}
.center-text{
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 20px;
  text-align: center;
  margin-top: 10px;
  span{
    color: #FF8622;
    cursor: pointer;
    img{
      width: 18px;
      height: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/pay/paymentStatus.vue